import "../styles/Home.css";
import { useEffect,useState } from "react";
import axios from "axios";
import BASE_URL from "../BaseUrl.jsx";
import { useNavigate } from "react-router-dom";
import LessonIcon from "../lesson.svg";
import Forume from "../forum.svg";
import Logo from "../elmanassa logo.png";
import test from "../test.svg";
import TeacherSlider from "./TeacherSlider";
export default function Home({setActive, pagesOut, setPagesOut}) {

  const navigate = useNavigate();
  const [bestTeachers, setBestTeachers] = useState([]);
  const getBestTeachers = () =>{
    axios.get(`${BASE_URL}/teacher/best-teachers`, { withCredentials: true })
    .then((response)=>{
      setBestTeachers(response.data);
    }).catch((error)=>{
      console.log(error);
    })
  }

  useEffect(()=>{
    getBestTeachers();
    setActive("الرئيسية");
  },[])
  return (
    <div className="home-div">
      {/* العنوان الرئيسي */}
      <header className="header">
        <h1 className={`${pagesOut.homeOut? "home-h-out": "home-h-in"}`}>
          مرحباً بك في منصة تفوَّق التعليمية
        </h1>
        <img src={Logo} alt="not found" style={{width:"100%", height:"100%"}}></img>
        <p className={`${pagesOut.homeOut? "home-p-out": "home-p-in"}`}>
          منصة تفوَّق التعليمية هي منصة تعليم إلكتروني للطلاب في مصر، توفر دروسًا وكورسات واختبارات تفاعلية في مختلف المواد الدراسية، مع إمكانية التعلم مع مدرسين متخصصين ومتابعة الدروس والاختبارات من خلال المنصة.
          </p>
      </header>

      {/* الأقسام الرئيسية */}
      <section className="">
      {bestTeachers.length > 0 && (<TeacherSlider teachers={bestTeachers}/>)}
        <div className="home-lessons">
          <img src={LessonIcon} alt="no"
            style={{width:"20%", height:"40%", marginTop:"10%"}}
            ></img>
          <div>
          <h2 className={`${pagesOut.homeOut? "home-h-out": "home-h-in"}`}>الدروس</h2>
          <div className="home-lessons-students">
            <h4 className={`${pagesOut.homeOut? "home-h-out": "home-h-in"}`}>الطلاب</h4>
            <p className={`${pagesOut.homeOut? "home-p-out": ""}`}>
                محتوى تعليمي شامل يغطي مختلف المواد مع فيديوهات وشروحات مبسطة.
            </p>
            <p className={`${pagesOut.homeOut? "home-p-out": "home-p-in"}`}>باقة من افضل المدرسين في جميع التخصصات, مع امكانية طرح الاسئلة حول كل درس ويمكن للطلاب الاخرين والمعلمين والمساعدين الرد علي سؤالك</p>
            <p className={`${pagesOut.homeOut? "home-p-out": "home-p-in"}`}>الدرس متاح طوال فترة الشراء ويمكنك مشاهدته في اي وقت, لكن من نفس الجهاز الذي قمت عليه بعملية الشراء</p>
            </div>
            <h4 className={`${pagesOut.homeOut? "home-h-out": "home-h-in"}`}>المعلمين</h4>
            <p className={`${pagesOut.homeOut? "home-p-out": "home-p-in"}`}>المنصة تم تطويرها من قبل فريق محترف مما جعلها تتيح ميزات جديدة ورائعة وكفائة عملية موثوقة</p>
            <p className={`${pagesOut.homeOut? "home-p-out": "home-p-in"}`}>خطط اسعار مختلفة ومرنة كما يمكنك تخصيص خطة تناسبك في قسم تخصيص الخطط</p>
            <p className={`${pagesOut.homeOut? "home-p-out": "home-p-in"}`}>اضافة مساعدين للمادة للمشاركة في ادارتها وتصحيح الواجب والامتحانات</p>
            <p className={`${pagesOut.homeOut? "home-p-out": "home-p-in"}`}>سهولة الادارة ومرونة المحتوي, تقديم استبيانات حول انشطة المساعدين</p>
            </div>
            
        </div>

        <div className="home-forums">
          <img src={Forume} alt="no" style={{width:"20%", height:"100px"}}></img>
          <div style={{width:"80%"}}>
          <h2 className={`${pagesOut.homeOut? "home-h-out": "home-h-in"}`}>
            المنتديات
          </h2>
          <p className={`${pagesOut.homeOut? "home-p-out": "home-p-in"}`}>
            تفاعل مع الزملاء والمحاضرين، اسأل الأسئلة وشارك خبراتك.
          </p>
          </div>
        </div>

        <div className="home-tests">
          <img src={test} alt="no" style={{width:"20%", height:"100px"}} />
          <div style={{width:"80%"}}>
            <h2 className={`${pagesOut.homeOut? "home-h-out": "home-h-in"}`}>
              الاختبارات
            </h2>
            <p className={`${pagesOut.homeOut? "home-p-out": "home-p-in"}`} >
              اختبارات ذاتية التصحيح وتعليل الحلول وبيان السبب
            </p>
          </div>
        </div>
      </section>

      {/* الدعوة للتسجيل */}
      <div className="mt-12 text-center">
        <button className="px-6 py-3 bg-blue-600 text-white rounded-xl text-lg shadow hover:bg-blue-700 transition"
          onClick={()=>{navigate("/logIn");setPagesOut({
          logInOut: false,
          homeOut: true,
          servicesOut: true,
          constactOut:true
        });}}
        >
          ابدأ الآن
        </button>
      </div>
    </div>
  );
}
